import PropTypes from "prop-types";
import React, { useState } from "react";
import { Form, Modal, ModalHeader, ModalBody, Button, FormGroup, Label, Input, FormFeedback } from "reactstrap";
import { withTranslation } from "react-i18next";
import { onUploadCSVFile } from "helpers/backend_api_helper";
import toastr from "toastr";

const CSVUploadModal = (props) => {
    const { modal, toggle, t ,batchId} = props;
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false)
    const [batchIdModal, setBatchId] = useState(batchId);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type === "text/csv") {
            setSelectedFile(file);
        } else {
            setSelectedFile(null);
        }
    };

    const handleSubmit = async(event) => {
        event.preventDefault();
        if (selectedFile) {
            setLoading(true);
            const formData = new FormData();
            formData.append("file", selectedFile);
            try {
                const response = await onUploadCSVFile(batchIdModal, formData);
                if(response?.status == 'success') {
                    setLoading(false);
                    toastr.success(response?.message);
                    toggle();
                }else{
                    toastr.error(response?.message);
                    setLoading(false);
                    toggle();
                }
            } catch (error) {
                setLoading(false);
                toggle();
                toastr.error(t("Server Error."));
            }

        } else {
            toastr.error(t("Please choose a CSV file."));
        }
    };

    return (
        <React.Fragment>
            <Modal 
                isOpen={modal}                     
                toggle={() => {
                    toggle()
                    setSelectedFile(null);
                }}
            >
                <ModalHeader 
                    toggle={() => {
                        toggle()
                        setSelectedFile(null);
                    }}
                >
                    {t("Import Participants")}
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label for="csvFile">{t("Upload CSV :")}</Label>
                            <Input type="file" id="csvFile" accept=".csv" onChange={handleFileChange} />
                        </FormGroup>
                        <div className="custm-btns">
                            {
                                loading 
                                    ? 
                                    <button disabled className="btn btn-primary">{t("Upload")}...</button>
                                    :
                                    <button type="submit"  className="btn btn-primary" >{t("Upload")}</button>
                            }
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

CSVUploadModal.propTypes = {
    modal: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default withTranslation()(CSVUploadModal);
